import Glide from "@glidejs/glide";
import Player from "@vimeo/player";
import { forAllCallback } from "kwp-core/scripts/utils/helpers";

export default () => {
    forAllCallback(".content-block.content-block--hero-slider", (el) => {
        const glideEl = el.querySelector(".glide");
        const slides = glideEl.querySelectorAll(".slide-wrapper");
        const seeMoreButton = el.querySelector(".see-more-button");

        if (seeMoreButton) {
            const nextSection = el.nextElementSibling;
            if (nextSection) {
                seeMoreButton.href = `#${nextSection.id}`;
            } else {
                seeMoreButton.style.display = "none";
            }
        }

        if (slides.length > 1) {
            const glide = new Glide(glideEl, {
                type: "carousel",
                gap: 0,
                animationDuration: 200,
                animationTimingFunc: "linear",
            });
            setTimeout(() => {
                glide.mount();
            }, 500);
        }

        slides.forEach((slide) => {
            if (isTypeYoutube(slide)) {
                const videoContainer = slide.querySelector(".video-container");
                const youtubeID = videoContainer.getAttribute("data-id");
                createYouTubePlayer(videoContainer, youtubeID);
            }

            if (isTypeVimeo(slide)) {
                const videoContainer = slide.querySelector(".video-container");
                const vimeoId = videoContainer.getAttribute("data-id");
                createVimeoPlayer(videoContainer, vimeoId);
            }
        });
    });
};

function createVimeoPlayer(el, id) {
    const videoContainer = el;
    const vimeoID = id;
    const options = {
        id: vimeoID,
        autoplay: true,
        background: true,
        byline: false,
        controls: false,
        loop: true,
        dnt: true,
        muted: true,
        playsinline: true,
        portrait: false,
        title: false,
    };
    const vimeoPlayer = new Player(videoContainer, options);
}

function createYouTubePlayer(el, id) {
    const videoContainer = el;
    const youtubeID = id;
    const options = {
        videoId: youtubeID,
        playerVars: {
            enablejsapi: 1,
            autoplay: 1,
            rel: 0,
            iv_load_policy: 3,
            showinfo: 0,
            modestbranding: 1,
            playsinline: 1,
            showinfo: 0,
            rel: 0,
            controls: 0,
            color: "white",
            loop: 0,
            mute: 1,
            playlist: youtubeID,
            wmode: "opaque",
            vq: "hd720",
        },
    };
    const ytIframeLoader = require("youtube-iframe");

    ytIframeLoader.load(function (YT) {
        new YT.Player(videoContainer, options);
    });
}

function isTypeYoutube(el) {
    return el.getAttribute("data-type") === "youtube";
}

function isTypeVimeo(el) {
    return el.getAttribute("data-type") === "vimeo";
}
